import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AssistantResponse,
  Conversation,
  SendMessagePayload
} from '../models/assistant.model';

@Injectable()
export abstract class AssistantDataService {
  abstract getConversations(): Observable<Conversation[]>;
  abstract getConversation(id: string): Observable<Conversation>;
  abstract createConversation(): Observable<Conversation>;
  abstract sendMessage(
    payload: SendMessagePayload
  ): Observable<AssistantResponse>;
  abstract deleteConversation(id: string): Observable<void>;
}
